import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { McqService } from '../../service/mcq.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';
import { DatePipe } from '@angular/common';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';


@Component({
  selector: 'app-dailyquizreport',
  templateUrl: './dailyquizreport.component.html',
  styleUrls: ['./dailyquizreport.component.css'],
  providers: [McqService,DatePipe],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})

export class DailyquizreportComponent implements OnInit {
  typetxt:any='';
  packageList:any=[];
  isPostLoad:any=true;
  msg:any='';
  isRemaningForum:any;
  postId:any=0;
  ngload:any;
  filter:any;
  noMoreResults:any;
  isError=false;
  siteUrl = this.global.websiteUrl;
  userId = 0;
  sectionName = [];
  isBackButton=false;
  myDate:any = new Date();


  constructor(private datePipe: DatePipe,private http:Http, private mcqservice:McqService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd HH:mm:ss');
    this.userId = commonService.user.id;
    this.ngload=true;
    this.packageList=[];
    let filter={};
    //filter={limit:10};
    this.getStudentDailyQuizReportList(filter);
  }

  ngOnInit() {
  }

  getStudentDailyQuizReportList(obj){
    obj['offset']=this.packageList.length?this.packageList.length:0;
    obj['studentId']=this.userId; //100610 
    console.log(this.myDate);
    obj['reportDate']=this.myDate; 
   
    this.mcqservice.getStudentDailyQuizReportList(obj).subscribe((data:any)=>{
     let finaldata = [];
      if(data.error==0){ 
        if(data.results.length > 0){
        Array.prototype.push.apply(this.packageList,data.results); 
        //console.log('daily quiz',this.packageList);
        this.isPostLoad=false;
        // get section data
        for(let p of data.results){
          this.getSectionNamePaperWise(p.paperId);
        }
      }else{
        this.isRemaningForum=false;
        this.isPostLoad=false;
        this.noMoreResults = true;
        this.packageList = [];
        //console.log('cccccc',this.noMoreResults);
      }

      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },(error : HttpErrorResponse)=>{    
      this.isPostLoad=false;  
      this.msg="internal server error!";
    });    
  }

  // get all sections name of each paper
  getSectionNamePaperWise(paperId){
    let obj = {};
    obj['paperId']=paperId; 
   
    this.mcqservice.getSectionNamePaperWise(obj).subscribe((data:any)=>{
     let finaldata = [];
      if(data.error==0){ 
        if(data.results.length > 0){
          this.sectionName[paperId] = data.results[0].sectionName;
      }else{
       // console.log("section name no Data found");
      }

      }else{
       // console.log("section name error in query");
      }
    },(error : HttpErrorResponse)=>{    
      //console.log("section name internal server error!");
    });    
  }

  reportUrl(tpid){
    return '../overallreport/'+btoa(tpid);
  }


  loadmorePackage(){
    //console.log('loadmoreForum');
    this.getStudentDailyQuizReportList({limit:10,isnewList:true});
  }

  @HostListener('window:scroll', ['$event'])
    checkScroll() {
       var scrollPosition = $(window).scrollTop() + $(window).height();
       //var pageheight =  $(document).height()
       var pageheight =  $(document).height()-$('#footer-section').outerHeight();
       if(scrollPosition >= pageheight && this.isRemaningForum==true && this.postId==0 && this.isPostLoad!=true) {
         this.isPostLoad=true;        
         this.loadmorePackage();
       }
 
  }
  
  getTotalMarks(data){
    /*let cm = data.positiveMark;
    let wm = data.negativeMark;
    let rq = data.totalRightAns;
    let wq = data.totalQuestions-data.totalRightAns-data.totalLeftAns;
    return Number((rq*cm) + (wq*wm)).toFixed(2);*/
    return Number((data.totalRightMarks) + (data.totalWrongMarks)).toFixed(2);
  }

  getTimeFormat(seconds, totalTime){
    totalTime  = Number(totalTime)*60;
    if(seconds>totalTime) seconds = totalTime;
    
    return this.mcqservice.getFormatTime(seconds);
  }
  

}







// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/dailyquizreport/dailyquizreport.component.ts